module.exports = __webpack_public_path__ + "img/two-hump-camel.d52020fb.png";